import React from 'react';
import { LoadingScreen } from './components/LoadingScreen';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { About } from './components/About';
import { Booking } from './components/Booking';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="relative w-full min-h-screen bg-brand-cream font-sans text-brand-mocha selection:bg-brand-rose/30" data-id="element-0">
      <LoadingScreen data-id="element-1" />
      <Header data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Services data-id="element-5" />
        <Gallery data-id="element-6" />
        <About data-id="element-7" />
        <Booking data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Contact data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
      <FloatingWhatsApp data-id="element-12" />
    </div>;
}